import React from "react";
import { Link } from "react-router-dom";
import "./subjectwisecards.css";
import mpscImg from "../../assets/test-series-image/mpsc.webp";
import { FiBookOpen, FiArrowRight, FiCheckCircle } from "react-icons/fi";

function SubjectWiseCards() {
  return (
    <div className="container my-4">
      <Link 
        to="/subject-wise-series/mpsc"
        className="mpsc-banner-bar bg-white rounded-3 shadow-sm border p-3 p-md-4 d-flex flex-column flex-md-row align-items-center justify-content-between cursor-pointer text-decoration-none text-dark d-block"
      >
        <div className="d-flex align-items-center gap-3 mb-3 mb-md-0">
          <img src={mpscImg} alt="MPSC Subject Wise Test Series" className="mpsc-banner-img" width="70" height="70" />
          <div>
            <div className="d-flex align-items-center gap-2 mb-1">
              <span className="badge bg-primary px-2 py-1 rounded-pill small">
                <FiBookOpen className="me-1" /> New Feature
              </span>
              <span className="badge bg-success bg-opacity-10 text-success border border-success px-2 py-1 rounded-pill small d-none d-sm-inline">
                <FiCheckCircle className="me-1" /> MPSC Special
              </span>
            </div>
            <h3 className="h4 fw-bold main-color mb-1">
              MPSC Subject-Wise Preparation & Topic-Wise Mock Tests
            </h3>
            <p className="text-muted mb-0 small">
              Master individual MPSC subjects & topics step-by-step with structured test series.
            </p>
          </div>
        </div>

        <span className="btn button-design px-4 py-2 rounded-pill fw-semibold d-flex align-items-center gap-2 text-nowrap mt-2 mt-md-0">
          Start MPSC Practice <FiArrowRight />
        </span>
      </Link>
    </div>
  );
}

export default SubjectWiseCards;
